import React, { useEffect, useCallback } from 'react'
import { SubmissionError } from 'redux-form'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import QS from 'qs'

import { sort } from '../../../../utils/arrays'

import {
  getDatabases,
  fetchDatabases,
  getLoading,
} from '../../../../ducks/databases'

import { createView } from '../../../../ducks/views'
import { getCurrentOrganizationId } from '../../../../ducks/users'
import Header from '../../../Shared/Header'
import { FullScreenLoader } from '../../../Shared/Loading'

import Form from './Form'

const getInitialValues = databases => {
  if (databases.length === 0) {
    return {}
  }

  const database = databases[0]
  const { schema } = database || {}
  const sorted = sort(schema || [], t => t.name)
  const table = sorted[0]

  return {
    body: {
      databaseId: database && database.id,
      table: table && table.name,
    },
  }
}

export default function NewView() {
  const history = useHistory()
  const dispatch = useDispatch()
  const organizationId = useSelector(getCurrentOrganizationId)
  const databases = useSelector(getDatabases(organizationId))
  const loading = useSelector(getLoading)

  useEffect(() => {
    dispatch(fetchDatabases(organizationId))
  }, [dispatch, organizationId])

  const handleSubmit = async values => {
    const { name, body } = values

    const data = {
      type: 'database',
      name,
      body,
    }

    try {
      const result = await dispatch(createView(organizationId, data))
      const { id } = result.value.data

      history.push(`/databases/views/${id}`)
    } catch (err) {
      throw new SubmissionError({
        _error: 'An unknown error occurred',
      })
    }
  }

  const handleChange = useCallback(
    values => {
      if (values.body && values.body.databaseId === 'new') {
        const query = { redirect: '/databases/create-view' }

        history.push(`/databases/new?${QS.stringify(query)}`)
      }
    },
    [history]
  )

  if (loading) {
    return <FullScreenLoader />
  }

  const initialValues = getInitialValues(databases)

  return (
    <>
      <Header>Create New View</Header>
      {loading ? (
        <FullScreenLoader />
      ) : (
        <Form
          onSubmit={handleSubmit}
          onChange={handleChange}
          databases={databases}
          initialValues={initialValues}
          onCancel={history.goBack}
        />
      )}
    </>
  )
}
